"use client";

import { useEffect, useState } from "react";

import { screenSizes } from "../constants";

interface UseMobileProps {
  breakpoint?: keyof typeof screenSizes;
  initialValue?: boolean;
}

export const getIsMobile = (breakpoint: keyof typeof screenSizes = "lg") =>
  typeof window !== "undefined" && window.innerWidth < screenSizes[breakpoint];

export const useMobile = ({ breakpoint = "lg", initialValue }: UseMobileProps = {}) => {
  const [isMobile, setIsMobile] = useState(() => initialValue ?? getIsMobile(breakpoint));

  useEffect(() => {
    const checkWindowSize = () => {
      // eslint-disable-next-line @eslint-react/hooks-extra/no-direct-set-state-in-use-effect -- it's also used in event listener
      setIsMobile(getIsMobile(breakpoint));
    };

    checkWindowSize();
    window.addEventListener("resize", checkWindowSize);

    return () => window.removeEventListener("resize", checkWindowSize);
  }, [breakpoint]);

  return isMobile;
};
